const identity = (x) => x
export default (reducer) => (state, action) => (reducer[action.type] || identity)(state, action)
